// extracted by mini-css-extract-plugin
export default {"startFeature":"button-action_startFeature__1XTfh","startFeature__button":"button-action_startFeature__button__oK4HI","gray":"button-action_gray__sTAsT"};